// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link_2hgB3","icon":"Link_icon_3dS_U","active":"Link_active_23vDH"};